<template>
    <div class="containContent">
        <div class="classFain">
            <div class="title">
          <span class="font-size18 perTit">
            <i class="el-icon-place font-weight"></i>
            {{ title }}
          </span>
            </div>
            <div class="content">
                <div class="left">
                    <span class="classificationText">机构分类：</span>
                </div>
                <div class="right">
                    <div class="frist ">
                        <div class="itemClass xy-center" v-for="(item,i) in options" :key="i"
                             :class="{'avtie' : perLibaryClassid.fristClassId === item.ClassId }"
                             @click="selectFrist(item)">
                            {{ item.ClassName }}
                        </div>
                    </div>
                    <div class="second " v-if=" optionsTwo.length">
                        <div class="itemClass xy-center" v-for="(item,i) in optionsTwo" :key="i"
                             :class="{'avtie' : perLibaryClassid.secondClassId === item.ClassId }"
                             @click="selectSecond(item)">
                            {{ item.ClassName }}
                        </div>
                    </div>
                    <div class="three " v-if="optionsTwo.length && optionsThree.length">
                        <div class="itemClass xy-center" v-for="(item,i) in optionsThree" :key="i"
                             :class="{'avtie' : perLibaryClassid.threeClassId === item.ClassId }"
                             @click="selectThree(item)">
                            {{ item.ClassName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    GetMedicalClass
} from "@/api/category"

export default {
    props: {
        type: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "机构题库"
        }
    },
    components: {},
    data() {
        return {
            options: [],
            optionsTwo: [],
            optionsThree: [],
            haveSelected: [],
            // 第一级给个默认classId
            perLibaryClassid: {
                fristClassId: "1000",
                secondClassId: "",
                threeClassId: ""
            }
        }
    },
    computed: {},
    watch: {},
    created() {
        // 机构题库
        this.GetMedicalClass()
    },
    methods: {
        async GetMedicalClass() {
            try {
                const {
                    data
                } = await GetMedicalClass({
                    ecid: -1
                });
                this.options = data.data
                this.options.splice(0, 0, { ClassName: "全部", ClassId: "1000" })
            } catch (err) {
                this.$toast("获取失败")
            }
        },
        async GetMedicalClassNav(val, num) {
            try {
                const {
                    data
                } = await GetMedicalClass({
                    ecid: val.ClassId
                });
                if (num === 1) {
                    this.optionsTwo = data.data
                } else if (num === 2) {
                    this.optionsThree = data.data
                }
            } catch (err) {
                this.$toast("获取失败")
            }
        },
        selectFrist(val) {
            console.log(val)
            if (val.ClassId === "1000") {
                this.optionsTwo = []
                this.optionsThree = []
                this.perLibaryClassid.fristClassId = val.ClassId
                this.$parent.passClassId = "1000"
                this.$emit("select", "1000")
                this.GetMedicalClass()
                return
            }
            this.perLibaryClassid.fristClassId = val.ClassId
            this.$parent.passClassId = val.ClassId
            this.optionsThree = []
            this.perLibaryClassid.secondClassId = ""
            this.GetMedicalClassNav(val, 1)
            this.$emit("select", val.ClassId)
        },
        selectSecond(val) {
            this.perLibaryClassid.secondClassId = val.ClassId
            this.$parent.passClassId = val.ClassId
            this.perLibaryClassid.threeClassId = ""
            this.GetMedicalClassNav(val, 2)
            this.$emit("select", val.ClassId)
        },
        selectThree(val) {
            this.perLibaryClassid.threeClassId = val.ClassId
            this.$parent.passClassId = val.ClassId
            this.GetMedicalClassNav(val)
            this.$emit("select", val.ClassId)
        }

    }
}

</script>

<style scoped lang="less">

.containContent {
    margin-top: 20px;

    .classFain {
        padding: 30px;
        box-sizing: border-box;
        background-color: white;

        .title {
            .perTit {
                font-weight: bold;
            }
        }

        .content {
            display: flex;
            margin-top: 40px;

            .left {
                width: 80px;
                margin-top: 8px;
                flex-shrink: 0;

                .classificationText {
                    font-size: 14px;
                    color: #72777F;
                }
            }

            .right {
                width: 100%;

                .itemClass {
                    padding: 0 20px;
                    box-sizing: border-box;
                    cursor: pointer;
                    height: 36px;
                    border-radius: 6px;
                    font-size: 14px;
                    color: #72777F;
                    margin-left: 15px;
                    float: left;
                }

                .avtie {
                    background-color: #2D98FE;
                    color: #fff;
                }

                .frist {
                    overflow: hidden;
                }

                .second {
                    overflow: hidden;
                    width: 100%;
                    margin-top: 20px;
                    background:#E5F2FF;
                    padding: 15px 5px;
                    box-sizing: border-box;
                }

                .three {
                    overflow: hidden;
                    width: 100%;
                    margin-top: 20px;
                    background: #F8FAFF;
                    padding: 15px 5px;
                    box-sizing: border-box;
                }
            }
        }
    }
}

</style>
